<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm">
    <ykc-form-item label="电站名称">
      <span>{{ row.stationName || '——' }}</span>
    </ykc-form-item>

    <ykc-form-item label="剔除方式" prop="operateObject">
      <ykc-radio
        :data="[
          { id: '1', name: '下拉多选' },
          { id: '2', name: '批量上传' },
        ]"
        @change="handleOperateObjectChange"
        v-model="ruleForm.operateObject"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item
      v-show="ruleForm.operateObject === '1'"
      label="白名单用户"
      prop="userAccountList">
      <el-select
        class="account-select"
        size="mini"
        v-model="ruleForm.userAccountList"
        multiple
        filterable
        clearable
        remote
        reserve-keyword
        placeholder="请输入用户账号检索"
        :loading="remoteSearchLoading"
        :remote-method="remoteMethod">
        <el-option
          v-for="item in accountOptions"
          :key="item.id"
          :label="item.userAccount"
          :value="item.userAccount"></el-option>
      </el-select>
    </ykc-form-item>

    <ykc-form-item v-show="ruleForm.operateObject === '2'" label="批量上传" prop="file">
      <ykc-upload
        class="user-upload"
        type="xlsx"
        :size="5"
        ref="file"
        :checkInfo="{ typeMess: '文件格式错误，请重新导入', sizeMess: '文件大小不超过' }"
        @handleRemove="handleRemove"
        @handleChange="fileUpload"
        :temText="linkText"
        :temhref="modelUrl"></ykc-upload>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { operationsStationChargeWhitelist } from '@/service/apis';

  export default {
    name: 'StationChargeWhitelistRemoveDrawer',
    props: {
      row: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        remoteSearchLoading: false,
        accountOptions: [],
        linkText: '白名单导入.xlsx',
        modelUrl: `${process.env.VUE_APP_OSS}/resource/白名单导入.xlsx`,
        ruleForm: {
          operateObject: '1',
          userAccountList: [],
          file: undefined,
        },
        rules: {
          userAccountList: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.operateObject === '1' && (!value || value.length === 0)) {
                  callback(new Error('请选择白名单用户'));
                  return;
                }
                callback();
              },
              trigger: 'change',
            },
          ],
          file: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.operateObject === '2' && !value) {
                  callback(new Error('请上传文件'));
                  return;
                }
                callback();
              },
              trigger: 'change',
            },
          ],
        },
      };
    },
    created() {
      this.remoteMethod('');
    },
    methods: {
      handleOperateObjectChange() {
        this.ruleForm.userAccountList = [];
        this.ruleForm.file = undefined;
        this.$nextTick(() => this.$refs.ruleForm.clearValidate());
      },
      remoteMethod(query) {
        this.remoteSearchLoading = true;
        operationsStationChargeWhitelist
          .accountOptions({
            stationId: this.row.stationId,
            userAccount: query,
          })
          .then(res => {
            this.accountOptions = res || [];
          })
          .finally(() => {
            this.remoteSearchLoading = false;
          });
      },
      handleRemove() {
        this.ruleForm.file = undefined;
        this.ruleForm.userAccountList = [];
      },
      fileUpload(file, fileList, isCheck) {
        if (!isCheck) {
          return;
        }
        this.ruleForm.file = file.raw;
        const formData = new FormData();
        formData.append('file', this.ruleForm.file);
        operationsStationChargeWhitelist
          .importUserAccounts(formData)
          .then(res => {
            this.$message.success('导入文件成功');
            this.ruleForm.userAccountList = (res?.importUserDTOS || []).map(
              item => item.userAccount
            );
          })
          .catch(() => {
            this.$refs.file.fileList = [];
          })
          .finally(() => {
            this.$refs.ruleForm.validateField('file');
          });
      },
      submitForm() {
        return new Promise(resolve => {
          this.$refs.ruleForm.validate(valid => {
            if (!valid) {
              return;
            }
            operationsStationChargeWhitelist
              .removeUsers({
                stationId: this.row.stationId,
                userAccountList: this.ruleForm.userAccountList,
              })
              .then(count => {
                this.$message.success(`成功从电站充电白名单中剔除${count || 0}人`);
                resolve();
              });
          });
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .account-select {
    width: 100%;
  }
  .user-upload {
    margin-bottom: 22px;
  }
</style>
